import { stockStatus, pageType } from './constants';
import { EVENT_NAME_FOR_PRODUCT_LIST } from '../../../packs/shop/constants/tracker';

export const sendRecommendItem = ({
  productId,
  basedProductIds,
  order,
  recStrategy,
  trackerService,
  layoutSetting,
}) => {
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.RecommendItem, {
    product_id: productId,
    rank: order,
    layout_setting: layoutSetting,
    page_type: pageType.CART_SIDEBAR,
    ...(basedProductIds?.length && { based_product_ids: basedProductIds }),
    ...(recStrategy && { rec_strategy: recStrategy }),
  });
};

export const sendViewRelatedProducts = ({
  product,
  basedProductIds,
  order,
  trackerService,
  layoutSetting,
}) => {
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.ViewRelatedProducts, {
    product_infos: [
      {
        id: product._id,
        status: product.sold_out
          ? stockStatus.OUT_OF_STOCK
          : stockStatus.IN_STOCK,
        rank: order,
        layout_setting: layoutSetting,
        page_type: pageType.CART_SIDEBAR,
        ...(basedProductIds?.length && { based_product_ids: basedProductIds }),
        ...(product.rec_strategy && {
          rec_strategy: product.rec_strategy,
        }),
      },
    ],
  });
};

export const sendProductImpression = ({ productId, trackerService }) => {
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.ProductImpression, {
    page_type: pageType.CART_SIDEBAR,
    product_id: productId,
  });
};

export const sendProductClick = ({ productId, trackerService }) => {
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.ProductClick, {
    page_type: pageType.CART_SIDEBAR,
    product_id: productId,
  });
};
